<template>
  <div class="produto-custom">
    <div class="produto-imagem" :class="{ odd: index % 2 === 0 }">
      <fullscreen :fullscreen.sync="produto.fullscreen" :teleport="false" :page-only="false">
        <div :class="{ 'fullscreen-wrapper': produto.fullscreen }" @click="produto.fullscreen = !produto.fullscreen">
          <img async :src="produto.Imagem" alt="" @click="produto.fullscreen = !produto.fullscreen" />
        </div>
      </fullscreen>
    </div>

    <div class="produto-descricao" :class="{ odd: index % 2 === 0 }">
      <div class="row">
        <div class="col-md-12">
          <span>
            <strong>{{ produto.Codigo }}-{{ produto.CodigoDv }}</strong> - {{ produto.SubGrupo }} {{ produto.Descricao }}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 produto-attr">
          <span class="new-badge"> {{ produto.Disponibilidade }} <i class="fa fa-check"></i></span>
          <span class="new-badge"> {{ produto.Garantia }} DE GARANTIA <i class="fa fa-check"></i></span>
          <span v-if="associado" class="new-badge"> PRODUTO ASSOCIADO <i class="fa fa-check"></i></span>
          <span v-if="produto.LinkFolheto" class="folhetos_produto">
            <a v-bind:href="produto.LinkFolheto" target="_blank">Folhetos <i class="fa fa-external-link"></i></a
          ></span>
        </div>
      </div>
    </div>

    <div class="produto-unidade">
      <span>{{ produto.Unidade }}</span>
    </div>

    <div class="produto-actions" :class="{ odd: index % 2 === 0, center: !produto.PodeAlterarQuantidade }">
      <div class="produto-qtde">
        <template v-if="!produto.PodeAlterarQuantidade || associado">
          <div class="text-center min-max-values-tooltip min-max-readonly-value">
            <span>{{ produto.Quantidade }}</span>
            <MinMaxToolTip v-if="!associado" :isReadOnly="true" :min="produto.Limites.QtdeMinima" :max="produto.Limites.QtdeMinima" />
          </div>
        </template>
        <template v-else>
          <button aria-label="Adicionar Produto" class="btn primary-button min-max-values-tooltip min-value" @click="subtractQtde(produto)">
            <i class="fa fa-minus-circle fa-lg"></i>
            <MinMaxToolTip :isMin="true" :value="produto.Limites.QtdeMinima" />
          </button>

          <input
            class="form-control text-center"
            v-model="produto.Quantidade"
            type="number"
            value="produto.Quantidade"
            @change="validarQtde(produto)"
          />

          <button aria-label="Adicionar Produto" class="btn primary-button min-max-values-tooltip max-value" @click="addQtde(produto)">
            <i class="fa fa-plus-circle fa-lg"> </i>
            <MinMaxToolTip :isMin="false" :value="produto.Limites.QtdeMaxima" />
          </button>
        </template>
      </div>
      <div class="btn-remover" v-if="produto.opcional && !associado">
        <button aria-label="Adicionar Produto" class="btn btn-danger" style="width: 100%" @click="removeInsumo(produto)">
          <i class="fa fa-trash fa-lg"></i> Remover
        </button>
      </div>
    </div>

    <div class="produto-valores" :class="{ odd: index % 2 === 0 }"style="display:none" >
      <div class="produto-valor-unit" :class="{ odd: index % 2 === 0 }">
        <span> R$ {{ produto.ValorUnitarioFormatado }} </span>
      </div>

      <div class="produto-valor" :class="{ odd: index % 2 === 0 }">
        <span> R$ {{ produto.ValorFormatado }} </span>
      </div>
    </div>
  </div>
</template>

<style type="text/css" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
  margin: 0px 10px;
  width: 65px;
}

.produto-custom {
  display: grid;
  align-items: center;
  grid-template-columns: 130px auto 45px 165px;
  border-radius: 4px;
}

.produto-imagem,
.produto-custom .produto-codigo,
.produto-custom .produto-descricao,
.produto-custom .produto-actions,
.produto-custom .produto-valores {
  padding: 0 10px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.produto-imagem img {
  max-height: 98px;
  cursor: pointer;
  transition: 0.6s;
}

.produto-imagem img:hover {
  transform: scale(1.08);
}

.produto-custom .produto-actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.produto-custom .produto-descricao {
  flex-direction: column;
  text-align: left;
  justify-content: center;
  align-items: flex-start;
}

.produto-custom .produto-valor-unit,
.produto-custom .produto-valor {
  width: 100px;
  text-align: right;
  white-space: nowrap;
}

.produto-custom .produto-valores {
  display: flex;
  justify-content: space-between;
}

.produto-imagem {
  padding: 5px;
}

.produto-custom .disponivel_produto {
  font-weight: bold;
  color: green;
  font-size: 13px;
  padding: 2px 0px;
}

.produto-attr {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}

.new-badge {
  background-color: #50a3d3;
  border-radius: 10px;
  color: white;
  display: inline-flex;
  font-size: 10px;
  font-weight: bold;
  justify-content: center;
  margin-right: 15px;
  padding: 3px 15px;
  width: 170px;
}

.new-badge .fa-check {
  color: rgb(108, 245, 108);
  margin-left: 5px;
  font-size: 15px;
}

.folhetos_produto {
  font-weight: bold;
  font-size: 12px;
  color: white;
  padding: 3px 15px 0 10px;
  border-radius: 10px;
  background-color: transparent;
}

.produto-custom .produto-qtde.center {
  justify-content: center;
}

.produto-custom .produto-qtde,
.produto-custom .produto-valor-unit,
.produto-custom .produto-valor {
  display: flex;
  justify-content: end;
  align-items: center;
}

.btn {
  border-radius: 8px;
}

.btn-remover {
  width: 100%;
  margin-top: 10px;
}

.produto-custom .odd {
  background-color: none;
}

.fullscreen-wrapper {
  width: 100%;
  height: 100%;
  background: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.fullscreen-wrapper img {
  width: 500px;
  max-height: none;
}

.fullscreen-wrapper img:hover {
  transform: scale(1);
}

@media (max-width: 600px) {
  .produto-custom .odd {
    background-color: #d8f1fe;
  }
}

@media (max-width: 600px) {
  .produto-custom .produto-descricao {
    font-size: 12px;
    grid-column: span 2;
  }

  .produto-custom .produto-attr {
    flex-direction: column;
    gap: 4px;
  }

  .produto-custom .produto-actions {
    grid-column: span 2;
    justify-content: center;
  }

  .produto-custom {
    grid-template-columns: 90px 80px auto;
  }

  .produto-imagem,
  .produto-custom .produto-descricao {
    height: 140px;
  }

  .produto-custom .produto-actions,
  .produto-custom .produto-valores {
    height: 100px;
  }
}
</style>

<script>
import MinMaxToolTip from './MinMaxToolTip'

export default {
  name: 'ProductInput',

  props: {
    produto: { type: Object, name: 'produto' },
    removeInsumo: { type: Function, name: 'removeInsumo' },
    addQtde: { type: Function, name: 'addQtde' },
    subtractQtde: { type: Function, name: 'subtractQtde' },
    validarQtde: { type: Function, name: 'validarQtde' },
    index: { type: Number, name: 'index' },
    associado: { type: Boolean, name: 'associado' },
  },

  components: {
    MinMaxToolTip,
  },
}
</script>
